import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAllBySolutionId({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/business/actions/bySolutionsID", { params: { id: id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
}
